import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store/store'
import router from './router'
import '@/plugins/keycloak'
Vue.config.productionTip = false
Vue.$keycloak
    .init({ onLoad: 'login-required'})           
    .then((auth) => {
      if (!auth) {
        window.location.reload()
      } else {
        //APIServices.setAuthHeader(Vue.$keycloak.token)
        new Vue({
          store,
          vuetify,
          router,
          render: h => h(App)
        }).$mount('#app')
       
      }
    }).catch(() => {
      console.log("Authenticated Failed");
    });

